// Port of api/fuel/app/classes/filter/search/games/rules/query/first_year_published.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'first_year_published',
	field: function() { return 'g.game_published' }
})
